import { render } from "./ussd-payment.vue?vue&type=template&id=07dac470&scoped=true"
import script from "./ussd-payment.vue?vue&type=script&lang=js"
export * from "./ussd-payment.vue?vue&type=script&lang=js"

import "./ussd-payment.vue?vue&type=style&index=0&id=07dac470&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dac470"]])

export default __exports__